import { Category } from '@backend/domain'
import { CategoryResponse } from '../types'

export class CategoryMapper {
	static categoryToResponse(category: Category): CategoryResponse {
		return {
			id: category.id,
			name: category.name,
			sortOrder: category.sortOrder,
			isArchived: category.isArchived,
			isVisible: category.isVisible,
			parentCategoryId: category.parentCategory?.id,
		}
	}
}
